// @flow

import _ from 'lodash';
import { $apply, $set, update } from 'qim';

import ActionTypes from 'app/billing/ActionTypes';
import { createReducer } from 'app/common/utils/ReduxUtils';

const initialState = {
  cardsOffset: undefined,
  changePlanError: null,
  currencies: {
    data: {},
    error: null,
    pending: false,
    selected: {
      icon: 'UnitedStates',
      multiplier: 1,
      name: 'USD',
      symbol: '$',
    },
  },
  isConfirmingPlanChange: false,
  isEditingCard: false,
  isInFlight: false,
  newAccountId: undefined,
  selectedBillingIntervals: {},
  understandsDowngrade: false,
};

const handlers = {
  [ActionTypes.CHANGE_PAGE](state, { newOffset }) {
    return update(['cardsOffset', $set(newOffset)], state);
  },

  [ActionTypes.SELECT_BILLING_INTERVAL](state, { planName, interval }) {
    return update(
      ['selectedBillingIntervals', planName, $set(interval)],
      state
    );
  },

  [ActionTypes.CONFIRM_PLAN_CHANGE](state, { newAccountId }) {
    return update(
      [
        ['isConfirmingPlanChange', $set(true)],
        ['newAccountId', $set(newAccountId)],
      ],
      state
    );
  },

  [ActionTypes.CHANGE_PLAN_ERROR](state, { message }) {
    return update(['changePlanError', $set(message)], state);
  },

  [ActionTypes.EDIT_CARD](state) {
    return update(['isEditingCard', $set(true)], state);
  },

  [ActionTypes.CANCEL_EDIT_CARD](state) {
    return update(['isEditingCard', $set(false)], state);
  },

  [ActionTypes.ON_LEAVE](state) {
    return update(['isConfirmingPlanChange', $set(false)], state);
  },

  [ActionTypes.TOGGLE_DOWNGRADE_UNDERSTOOD](state) {
    return update(['understandsDowngrade', $apply(_.negate(Boolean))], state);
  },

  [ActionTypes.SET_IN_FLIGHT](state, { isInFlight }) {
    return update(['isInFlight', $set(isInFlight)], state);
  },

  [ActionTypes.GET_CURRENCY_RATES](state) {
    return update(
      ['currencies', ['error', $set(null)], ['pending', $set(true)]],
      state
    );
  },

  [ActionTypes.GET_CURRENCY_RATES_DONE](state, { data }) {
    return update(
      [
        'currencies',
        ['data', $set(data)],
        ['error', $set(null)],
        ['pending', $set(false)],
      ],
      state
    );
  },

  [ActionTypes.GET_CURRENCY_RATES_FAIL](state, { error }) {
    return update(
      ['currencies', ['error', $set(error)], ['pending', $set(false)]],
      state
    );
  },

  [ActionTypes.SELECT_CURRENCY](state, { currency }) {
    return update(['currencies', ['selected', $set(currency)]], state);
  },
};

export default createReducer(handlers, initialState);
